// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  call_to_action: dynamic(() => import("./CallToAction")),
  hero: dynamic(() => import("./Hero")),
  image: dynamic(() => import("./Image")),
  list: dynamic(() => import("./List")),
  navigation: dynamic(() => import("./NavigationHeader")),
  navigation_footer: dynamic(() => import("./NavigationFooter")),
  newsletter_archive: dynamic(() => import("./NewsletterArchive")),
  page_intro: dynamic(() => import("./Text")),
  partners: dynamic(() => import("./Partners")),
  project_timeline: dynamic(() => import("./ProjectTimeline")),
  publication: dynamic(() => import("./Publication")),
  text_with_image: dynamic(() => import("./TextWithImage")),
};
